/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Unavailable_BodyInputs */

const en_setup_unavailable_body = /** @type {(inputs: Setup_Unavailable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link has already been used or is wrong. Sign in instead.`)
};

const de_setup_unavailable_body = /** @type {(inputs: Setup_Unavailable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Link wurde schon benutzt oder ist falsch. Melde dich stattdessen an.`)
};

/**
* | output |
* | --- |
* | "This link has already been used or is wrong. Sign in instead." |
*
* @param {Setup_Unavailable_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const setup_unavailable_body = /** @type {((inputs?: Setup_Unavailable_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Unavailable_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_setup_unavailable_body(inputs)
	return en_setup_unavailable_body(inputs)
});